import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useParams } from "react-router-dom";
import awsService from "../services/awsService";
import shareService from "../services/shareService";
import { useStateContext } from "../contexts/ContextProvider";
import "./viewfile.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../components/Loading";
import LinkExpiredPage from "../components/LinkExpiredPage ";
const ViewHTMl = () => {
  const { currentColor, currentMode } = useStateContext();
  const [uploading, setupLoading] = useState(false);
  const [downloading, setdownloading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [sharedData, setsharedData] = useState({});
  const [writeAccess, setWriteAccess] = useState(false);
  const [showShareModal, setShowShareModal] = useState(true);
  const [sharePassword, setSharePassword] = useState("");
  const [userPrefix, setUserPrefix] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [Filename, setFilename] = useState("");
  const [htmlLink, setHtmlLink] = useState("");
  const [isLinkExpired, setIsLinkExpired] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const params = useParams();

  useEffect(() => {
    getFilename();
  }, []);
  const handleShare = async () => {
    setLoading(true);
    try {
      const response = await shareService.getSingleShare(params.id, {
        password: sharePassword,
      });
    setLoading(false);

      if (response.status == "error") {
        setLoading(false);
        toast.error("Link Expired", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      if (response) {
        setsharedData(response);
        setWriteAccess(response.uploadAccess);

        const prefix = response.fileData.Key || response.fileData.Prefix;
        setUserPrefix(prefix);
        const response2 = await awsService.gethtmlindex({
          shareId: response.shareId,
        });
        console.log(response2);
        setHtmlLink(response2);

        // if (response2) {
        //   setLoading(false);
        // }
        setShowShareModal(false);
      } else {
        setShowShareModal(true);
        toast.error("Link Expired", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      if (error && error.response && error?.response?.data.status === "error") {
        let errormsg = error.response?.data.message || "Link Expired";
        toast.error(errormsg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("Internal Server Error", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      console.error("Error sharing file:", error);
    }
  };
  const getFilename = async () => {
    try {
      const response = await shareService.getFilename(params.id, {});
      if (response.status == "error") {
        setIsLinkExpired(true);
        toast.error("Link Expired", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      if (response) {
        console.log(response);
        let file = response.data.filename
          .split("/")
          .filter((part) => part !== "")
          .pop();
        let filename = file.substring(file.lastIndexOf("-") + 1);
        if(response.data.noPassword){
          setLoading(true);
          handleShare();
        }else{
          setFilename(filename);

        }
        console.log(response);
        setLoading(false);
      } else {
        setIsLinkExpired(true);
        toast.error("Link Expired", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      setIsLinkExpired(true);
      toast.error("Link Expired", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.error("Error sharing file:", error);
    }
  };

  return (
    <>
      {!isLinkExpired ? (
        <div className="w-full ">
          {/* {!showShareModal && <img className="ml-5  mt-4 h-10 " src="/docbox.png" alt="Logo" />} */}
          {loading && (
            <Loading loading={"loading"} currentColor={currentColor} />
          )}

          <div className="mx-auto max-w-screen-lg">
            {" "}
            {/* <style>
          {`
      body {
       
        background-size: 50%; 
        background-repeat: repeat;
        overflow:hidden
        margin: 0;
        padding: 0;
      }
    `}
        </style> */}
            {!showShareModal ? (
              <Container fluid className="p-4">
                {uploading && (
                  <div className="fixed top-0 left-0 z-50 w-full h-full flex flex-col items-center justify-center bg-gray-900 bg-opacity-50 text-white">
                    <div
                      className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2"
                      style={{
                        borderTopColor: "white",
                        borderBottomColor: "white",
                      }}
                    ></div>
                    <p className="mt-4">loading... {progress}%</p>
                    <div className="progress w-3/4 mt-2">
                      <div
                        className="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        style={{ width: `${progress}%` }}
                        aria-valuenow={progress}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        {progress}%
                      </div>
                    </div>
                  </div>
                )}
                {downloading && (
                  <div className="fixed top-0 left-0 z-50 w-full h-full flex flex-col items-center justify-center bg-gray-900 bg-opacity-50 text-white">
                    <div
                      className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2"
                      style={{
                        borderTopColor: "white",
                        borderBottomColor: "white",
                      }}
                    ></div>
                    <p className="mt-4">Downloading... {progress}%</p>
                    <div className="progress w-3/4 mt-2">
                      <div
                        className="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        style={{ width: `${progress}%` }}
                        aria-valuenow={progress}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        {progress}%
                      </div>
                    </div>
                  </div>
                )}

                {htmlLink ? (
                  <div
                    style={{
                      width: "100vw",
                      height: "100vh",
                      margin: 0,
                      padding: 0,
                      position: "fixed",
                      top: 0,
                      left: 0,
                    }}
                  >
                    <iframe
                      src={htmlLink}
                      width="100%"
                      height="100%"
                      title="Grid View"
                      onLoad={() => setLoading(false)}
                      style={{ border: "none" }}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; fullscreen; gyroscope; picture-in-picture"
                    ></iframe>
                  </div>
                ) : (
                  <Loading loading={"loading"} currentColor={currentColor} />
                )}
              </Container>
            ) : Filename ? (
              <div className="flexbox">
                <div className="flexCenterBox">
                  <div className="logoBox">
                    <img
                      src="/doclogo-horizontal.png"
                      alt="DocBox Logo"
                      className=" h-12 w-48 "
                    />
                  </div>
                  <div className="card shadow">
                    <div className="card-header">
                      <h5 className="card-title text-center p-3">
                        Please Enter Password
                      </h5>
                    </div>
                    <div className="card-body p-4">
                      <p className="mb-4">
                        You've received a link to a file that requires a
                        password.
                      </p>
                      <div
                        className="filename-container mb-4 text-center"
                        style={{
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                          background: "#f8f9fa",
                          padding: "10px",
                        }}
                      >
                        <h4 className="filename">{Filename}</h4>
                      </div>
                      <p className="mb-4">
                        To open the content, enter the password. If you don't
                        have the link password, ask the person who shared the
                        content with you.
                      </p>
                      <div className="input-group mb-4">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          placeholder="Password"
                          value={sharePassword}
                          onChange={(e) => setSharePassword(e.target.value)}
                        />
                        <span
                          className="input-group-text password-toggle"
                          onClick={togglePasswordVisibility}
                          style={{ cursor: "pointer" }}
                        >
                          {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                      </div>
                      <button
                        className="btn btn-primary w-100"
                        onClick={() => {
                          setLoading(true);
                          handleShare();
                        }}
                        style={{ backgroundColor: "#036bb3" }}
                      >
                        Verify
                      </button>
                    </div>
                    {/* <div className="card-footer">
              <button className="btn btn-primary w-100" onClick={handleShare}>Verify</button>
            </div> */}
                  </div>
                </div>
              </div>
            ) : (
              <Loading loading={"loading"} currentColor={currentColor} />
            )}
            <div>
              <ToastContainer />
            </div>
          </div>
        </div>
      ) : (
        <LinkExpiredPage />
      )}
    </>
  );
};

export default ViewHTMl;
